export default __webpack_public_path__ + "static/media/Aiden_Wu.a3a640d9.webp";